import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IReserveBreakdown } from '../../api/interfaces'
import { ThemeContext } from '../../App'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getLiqFeesConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_reserves_breakdown', timeframe)) as IReserveBreakdown[]
	console.log(chartData)
	const series1 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.LIQ_FEES_USD }
	})
	const series2 = chartData.map((element: IReserveBreakdown) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.LIQ_FEES_USD_CUMULATIVE }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'liq fees',
			type: 'bars',
			seriesGroup: '[usd]',
			color: 'green',
			unitSymbol: '$'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'liq fees cumulative',
			type: 'line',
			seriesGroup: ' [usd]',
			color: 'orange',
			unitSymbol: '$'
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}
const LiqFees = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getLiqFeesConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Liquidity Fees"
			chartDesc="Fees paid by users (swap fees, liq adds/withdrawals, saver adds/withdrawals)."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="9bda51b5-c3ad-4ab6-abd8-17a004ace38d"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			// startZoom={1631829600}
			// endZoom={1666476000}
			hasHours={false}
			reverseLegend={true}
		/>
	)
}

export default LiqFees
